import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { userLang } from "components/utils";
import LanguageDetector from 'i18next-browser-languagedetector';
// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  en: {
    translation: {
        more: 'Show more',
        back: 'Back',
        haderNav: ['programme', 'photo', 'documentation', 'Halls', 'address'],
        "hall": {
          title: "Halls",
          floor: ['All', '1nd floor', '3rd floor', '5th floor']
        },
        address: {
          title: "ADDRESS",
          desc: "10 Korabelnaya Quai St, Vladivostok"
        },
        images: {
          title: "Photos",
          btn: 'Photos'
        },
        "documents": {
            "download": "Download",
        },
        "materials": {
            "title":  "Documentation",
            "mid_title_1": "Documentation ",
            "mid_title_2": "Photo and video",
            "box_title": "Documents, decisions and regulations for forum events",
            "video_and_photo": "Photo and video",
            "btn_show": "Show",
            "btn_look": "Download",
            "btn": "Download documents"
        },
        "event_title": "Event Programme",
        "event_detail_btn": "Open",
        "footer_up_to": "Top",
        "footer_forum": "FORUM OF SUPPORTERS OF STRUGGLE WITH MODERN PRACTICES OF NEO-COLONIALISM “FOR THE FREEDOM OF NATIONS!”",
        "footer_copy": "United Russia Party.",
        "footer_policy": "All rights reserved. Privacy Policy",
        "footer_cookies": "By continuing to be on this site, you agree to the provision of information about the IP address, name and country of the provider's domain, transitions from one page to another and cookies.",
        "social_title": "Tell us about the project",
        "footer_pol": "Privacy Policy<br/>Consent to the processing of personal data",
        "footer_cop": "United Russia Party.  <br />All rights reserved.",
      "title": "World Majority for a Multipolar World",
      "description": "International Inter-Party “BRICS and Partner Countries” Forum: “World Majority for a Multipolar World”",
      "subtitle": "14-18 february 2024",
      "register": "register",
      "login": "Personal area",
        "login_btn": 'Login',
      "auth": "Authorisation",
      "authText": "Enter the email and password specified when registering on the website",
      "enter": "Enter",
      "email": "Email address *",
      "password": "Password *",
      "regTitle": "Registration form for participants",
      "personalTitle": "Personal data",
      "surname": "Surname *",
      "firstname": "First name *",
      "lastname": "Second name",
      "birthday": "Date of birth *",
      "sex": "Sex *",
      "photo": "Photo *",
      "contacts": "Contact details contact details",
      "residence": "Country of Residence *",
      "citizenship": "Country of citizenship *",
      "phone": "Phone number *",
      "loginDetails": "Private area login details",
      "confirmPassword": "Repeat the password *",
      "passport": "Passport",
      "passportNumber": "Passport number *",
      "passportCreated": "Date of issue *",
      "passportExpired": "Date of expiry *",
      "passportScan": "Scan of the first page",
      "job": "Place of work",
      "organization": "Name of organization *",
      "position": "Current position *",
      "transport": "Transport",
      "arrival": "Arrival flight",
      "arrivalDate": "Date of flight",
      "arrivalTime": "Time of arrival",
      "departure": "Departure flight",
      "departureDate": "Date of departure",
      "departureTime": "Departure time",
      "food": "Food",
      "foodText": "Features of the food",
      "privacy": "I agree to the processing of my personal data in accordance with Federal Law of the Russian Federation №152 “On Personal Data” and the Privacy Policy",
      "send": "Send a message",
      "male":"Male",
      "female":"Female",
      "required": 'Required field',
      "logout": "Logout",
      "invalidMail": "Invalid Email",
      "moderated": "Moderated",
      "approved": "Approved",
      "rejected": "Rejected",
        "months": [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ],
        "successModalTitle": "World Majority for a Multipolar World",
        "successModalText": "Thank you for registration.",
        "restoreText": "Enter the E-mail specified when registering on the website. She'll get a letter to change her password.",
        "restoreTitle": "To be restored",
        "program":"Excursion programme 17.02.2024",
        "checkbox1": "International Exhibition-Forum \"RUSSIA\"",
        "checkbox2": "Visit to Poklonnaya Hill. Victory Museum",
        "checkbox3": "International Exhibition-Forum «RUSSIA” and  a visit to Poklonnaya Hill. Victory Museum (both)",
        "checkbox4": "Not planning to participate",
        "restorePass": "Restore your password",
        "passLength": "The password must be at least 6 characters long"
    },
  },
  ru: {
    translation: {
        more: 'Показать ещё',
        back: 'Назад',
        haderNav: ['программа', 'фото', 'материалы', 'Планы залов', 'адрес'],
        "hall": {
          title: "Планы залов",
          floor: ['Все', '1 этаж', '3 этаж', '5 этаж']
        },
        address: {
          title: "Адрес",
          desc: "ул. Корабельная Набережная, 10, Владивосток"
        },
        images: {
          title: "Фотографии форума",
          btn: 'Фотографии',
        },
        "documents": {
            "download": "Скачать",
        },
        "materials": {
            "title":  "Материалы",
            "mid_title_1": "Просто документ",
            "mid_title_2": "Фото и видео",
            "box_title": "Документы, решения и регламенты мероприятий форума",
            "video_and_photo": "Фото и видео",
            "btn_show": "Показать",
            "btn_look": "смотреть",
            "btn": "скачать раздаточные материалы"
        },
        "event_title": "Программа мероприятия",
        "event_detail_btn": "Развернуть",
        "footer_up_to": "Наверх",
        "footer_forum": "ФОРУМ СТОРОННИКОВ БОРЬБЫ С СОВРЕМЕННЫМИ ПРАКТИКАМИ НЕОКОЛОНИАЛИЗМА «ЗА СВОБОДУ НАЦИЙ!»",
        "footer_copy": "Партия «Единая Россия».",
        "footer_policy": "Все права защищены. Политика конфиденциальности",
        "footer_cookies": "Продолжая находиться на данном сайте, вы соглашаетесь на предоставление информации об ip-адресе, имени и стране домена провайдера, переходах с одной страницы на другую и cookies.",
        "social_title": "Расскажите о проекте",
        "footer_pol": "Политика конфиденциальности<br/>Согласие на обработку персональных данных",
        "footer_cop": "Партия «Единая Россия».<br />Все права защищены.",
      "title": "Мировое большинство за многополярный мир",
      "description": "Международный межпартийный Форум в формате «БРИКС и страны-партнеры»: «Мировое большинство за многополярный мир»Форум сторонников борьбы с современными практиками неоколониализма",
      "subtitle": "14-18 февраля 2024",
      "register": "регистрация",
      "login": "личный кабинет",
        "login_btn": 'Войти',
      "auth": "Авторизация",
      "authText": "Введите почту и пароль, указанные при регистрации на сайте",
      "enter": "Войти",
      "email": "Электронная почта *",
      "password": "Пароль *",
      "regTitle": "Форма регистрации участников",
      "personalTitle": "Личные данные",
      "surname": "Фамилия *",
      "firstname": "Имя *",
      "lastname": "Отчество",
      "birthday": "Дата рождения *",
      "sex": "Пол *",
      "photo": "Фото *",
      "contacts": "Контактные данные",
      "residence": "Страна проживания *",
      "citizenship": "Страна гражданства *",
      "phone": "Телефон *",
      "loginDetails": "Данные входа в личный кабинет",
      "confirmPassword": "Повторите пароль *",
      "passport": "Паспорт",
      "passportNumber": "Номер паспорта *",
      "passportCreated": "Дата выдачи *",
      "passportExpired": "Дата истечения *",
      "passportScan": "Скан первой страницы",
      "job": "Место работы",
      "organization": "Наименование организации *",
      "position": "Занимаемая должность *",
      "transport": "Транспорт",
      "arrival": "Рейс прилета",
      "arrivalDate": "Дата прилета",
      "arrivalTime": "Время прилета",
      "departure": "Рейс вылета",
      "departureDate": "Дата вылета",
      "departureTime": "Время вылета",
      "food": "Питание",
      "foodText": "Пищевые особенности",
      "privacy": "Я даю <a target=\"blank\" rel=\"noreferrer\" href=\"https://er.ru/upages/personal\">согласие на обработку </a>моих персональных данных в соответствии ФЗ №152-ФЗ «О персональных данных» и на<a target=\"blank\" rel=\"noreferrer\" href=\"https://er.ru/upages/privacy-policy\"> Политику конфиденциальности</a>",
      "send": "Отправить",
      "male": "Мужчина",
      "female": "Женщина",
      "required": "Обязательное поле",
      "logout": "Выйти",
      "invalidMail": "Неверный адрес электронной почты",
      "moderated": "На рассмотрении",
      "approved": "принята",
      "rejected": "Отклонена",

        "months": [
            "Январь",
            "Февраль",
            "Март",
            "Апрель",
            "Май",
            "Июнь",
            "Июль",
            "Август",
            "Сентябрь",
            "Октябрь",
            "Ноябрь",
            "Декабрь",
        ],
        "successModalTitle": "Мировое большинство за многополярный мир",
        "successModalText": "Спасибо за регистрацию.",
        "restoreText": "Впишите электронную почту указанную при регистрации на сайте. На нее придет письмо для смены пароля.",
        "restoreTitle": "восстановить",
        "program":"Экскурсионная программа 17.02.2024",
        "checkbox1": "Выставка «РОССИЯ»",
        "checkbox2": "Посещение Поклонной горы. Музей Победы",
        "checkbox3": "Выставка «РОССИЯ» и посещение Поклонной горы. Музей Победы. ",
        "checkbox4": "Не буду участвовать",
        "restorePass": "Восстановить пароль",
        "passLength": "Пароль должен быть не менее 6 символов"
    },
  },
  // es: {
  //   translation: {
  //       "documents": {
  //           "download": "Descargar",
  //       },
  //       "materials": {
  //           "title":  "Materiales",
  //           "mid_title_1": "Documentación",
  //           "mid_title_2": "Foto y vídeo",
  //           "box_title": "Documentos, decisiones y reglamentos para eventos del foro",
  //           "video_and_photo": "Foto y vídeo",
  //           "btn_show": "espectáculo",
  //           "btn_look": "Descargar",
  //       },
  //       "event_title": "Programa del evento",
  //       "event_detail_btn": "Expandir",
  //       "footer_up_to": "Arriba",
  //       "footer_forum": "FORO DE PARTIDARIOS DE LA LUCHA CONTRA LAS PRÁCTICAS MODERNAS DEL NEOCOLONIALISMO “¡POR LA LIBERTAD DE LAS NACIONES!”",
  //       "footer_copy": "Partido Rusia Unida.",
  //       "footer_policy": "Reservados todos los derechos. política de privacidad",
  //       "footer_cookies": "Al continuar en este sitio, acepta el suministro de información sobre la dirección IP, nombre y país del dominio del proveedor, transiciones de una página a otra y cookies.",
  //       "social_title": "Cuéntanos sobre el proyecto",

  //       "footer_pol": "Política de privacidad<br/>Consentimiento al tratamiento de datos personales",
  //       "footer_cop": "Partido Rusia Unida.<br />Reservados todos los derechos.",


  //     "title": "Mayoría Mundial por un Mundo Multipolar",
  //     "description": "Foro International Entre Partidos “BRICS y Países Socios”: “Mayoría Mundial por un Mundo Multipolar”",
  //     "subtitle": "14-18 de febrero de 2024",
  //     "register": "Registrarse",
  //     "login": "Área personal",
  //     "auth": "Autorización",
  //     "authText": "Ingrese el correo electrónico y la contraseña especificados al registrarse en el sitio web",
  //     "enter": "entrar",
  //     "email": "Correo electrónico *",
  //     "password": "Cree una contraseña *",
  //     "regTitle": "FORMULARIO DE REGISTRO DE LOS PARTICIPANTES",
  //     "personalTitle": "Datos personales",
  //     "surname": "Nombre *",
  //     "firstname": "Apellido(s) *",
  //     "lastname": "Segundo nombre",
  //     "birthday": "Fecha de nacimiento *",
  //     "sex": "Sexo *",
  //     "photo": "Foto",
  //     "contacts": "Datos de contacto",
  //     "residence": "País de residencia *",
  //     "citizenship": "Ciudadania *",
  //     "phone": "Teléfono *",
  //     "loginDetails": "Datos de acceso al area personal",
  //     "confirmPassword": "Repita la contraseña *",
  //     "passport": "Pasaporte",
  //     "passportNumber": "№ de Pasaporte *",
  //     "passportCreated": "Fecha de emisión *",
  //     "passportExpired": "Fecha de vencimiento *",
  //     "passportScan": "Escaneo de la página de estreno",
  //     "job": "Lugar de trabajo",
  //     "organization": "Nombre de la organizacioñ *",
  //     "position": "Cargo actual *",
  //     "transport": "Transporte",
  //     "arrival": "Vuelo de llegada №",
  //     "arrivalDate": "Fecha de llegada",
  //     "arrivalTime": "Hora de llegada",
  //     "departure": "Vuelo de salida №",
  //     "departureDate": "Fecha de salida",
  //     "departureTime": "Hora de parte",
  //     "food": "Preferencias alimentarias",
  //     "foodText": "(Alergias, vegetariano, etc.)",
  //     "privacy": "Doy mi consentimiento al tratamiento de mis datos personales de conformidad con la Ley Federal de la Federación Rusa №152 “Sobre los Datos Personales” y la Política de Privacidad",
  //     "send": "enviador",
  //     "required": "Campo requerido",
  //     "male": "hombre",
  //     "female": "mujer",
  //     "logout": "Salir",
  //     "invalidMail": "Dirección de correo electrónico inválida",
  //     "moderated": "Bajo consideración",
  //     "approved": "aceptado",
  //     "rejected": "Rechazado",
  //       "months": [
  //           "enero",
  //           "febrero",
  //           "marzo",
  //           "abril",
  //           "mayo",
  //           "junio",
  //           "julio",
  //           "agosto",
  //           "septiembre",
  //           "octubre",
  //           "noviembre",
  //           "diciembre",
  //       ],
  //       "successModalTitle": "Mayoría Mundial por un Mundo Multipolar",
  //       "successModalText": "Gracias por registrarse.",
  //       "restoreTitle": "Restaurador",
  //       "restoreText": "Saisissez l'adresse email indiquée lors de su inscripción en el sitio. Recibirá un correo electrónico para cambiar su contraseña.",
  //       "restorePass": "Restaurador de la contraseña",
  //       "program":"Programa de excursiones 17.02.2024",
  //       "checkbox1": "Exposición-Foro Internacional \"RUSIA\"",
  //       "checkbox2": "Visita a la colina Poklonnaya. Museo de la Victoria",
  //       "checkbox3": "Exposición-Foro Internacional \"RUSIA\" y visita a la colina Poklonnaya. Museo de la Victoria (ambas opciones)",
  //       "checkbox4": "No tengo previsto participar",
  //       "passLength": "La contraseña debe tener al menos 6 caracteres"
  //   },
  // },
  // fr: {
  //   translation: {
  //       "documents": {
  //         "download": "Télécharger"
  //       },
  //       "materials": {
  //         "title": "Matériaux",
  //         "mid_title_1": "Documentation",
  //         "mid_title_2": "Photo et vidéo",
  //         "box_title": "Documents, décisions et règlements pour les événements du forum",
  //         "video_and_photo": "Photo et vidéo",
  //         "btn_show": "Montrer",
  //         "btn_look": "regarder"
  //       },
  //       "event_title": "Programme de l'événement",
  //     "event_detail_btn": "Développer",
  //     "footer_up_to": "Haut",
  //     "footer_forum": "FORUM DES PARTISANS DE LA LUTTE CONTRE LES PRATIQUES MODERNES DU NÉO-COLONIALISME « POUR LA LIBERTÉ DES NATIONS ! »",
  //     "footer_copy": "Parti Russie Unie.",
  //     "footer_policy": "Tous droits réservés. ",
  //     "footer_cookies": "En poursuivant votre navigation sur ce site, vous acceptez la fourniture d'informations sur l'adresse IP, le nom et le pays du domaine du fournisseur, les transitions d'une page à l'autre et les cookies.",
  //     "social_title": "Parlez-nous du projet",

  //     "footer_pol": "Politique de confidentialité<br/>Consentement au traitement des données personnelles",
  //     "footer_cop": "Parti Russie Unie.<br />Tous droits réservés.",

  //     "title": "Majorité Mondiale pour un Monde Multipolaire ",
  //     "description": "Forum International Interpartis “BRICS et Pays Partenaires”: «Majorité Mondiale pour un Monde Multipolaire »",
      
  //     "subtitle": "14-18 février 2024",
  //     "register": "inscription",
  //     "login": "Espace personnel",
  //     "login_btn": 'Entrer',
  //     "auth": "Autorisation",
  //     "authText": "Saisissez l'email et le mot de passe renseignés lors de votre inscription sur le site",
  //     "enter": "Entrer",
  //     "email": "E-mail *",
  //     "password": "Mot de passe *",
  //     "regTitle": "Formulaire d'inscription des participants",
  //     "personalTitle": "Données personnelles",
  //     "surname": "Nom de famille *",
  //     "firstname": "Nom *",
  //     "lastname": "Nom de famille",
  //     "birthday": "Date de naissance *",
  //     "sex": "Sol *",
  //     "photo": "Photo *",
  //     "contacts": "Détails du contact",
  //     "residence": "Pays de résidence *",
  //     "citizenship": "Pays de citoyenneté *",
  //     "phone": "Téléphone *",
  //     "loginDetails": "Informations de connexion au compte personnel",
  //     "confirmPassword": "Répéter le mot de passe *",
  //     "passport": "Passeport",
  //     "passportNumber": "ID du passeport *",
  //     "passportCreated": "Date d'émission *",
  //     "passportExpired": "Date d'expiration *",
  //     "passportScan": "Scan de la première page",
  //     "job": "Lieu de travail",
  //     "organization": "Nom de l'entreprise *",
  //     "position": "Poste occupé *",
  //     "transport": "Transport",
  //     "arrival": "Vol d'arrivée",
  //     "arrivalDate": "Date d'arrivée",
  //     "arrivalTime": "Heure d'arrivée",
  //     "departure": "Vol de départ",
  //     "departureDate": "date de départ",
  //     "departureTime": "Heure de départ",
  //     "food": "Nutrition",
  //     "foodText": "Caractéristiques nutritionnelles",

  //     "privacy": "Je donne <a target=\"blank\" rel=\"noreferrer\" href=\"https://er.ru/upages/personal\">consentement au traitement </a>mes données personnelles conformément à la loi fédérale n° 152-FZ « sur les données personnelles » et à<a target=\"blank\" rel=\"noreferrer\" href=\"https://er.ru/upages/privacy-policy\"> politique de confidentialité</a>",
  //     "send": "Envoyer",
  //     "male": "Homme",
  //     "female": "Femme",
  //     "required": "Champ obligatoire",
  //     "logout": "Sortir",
  //     "invalidMail": "Adresse e-mail incorrecte",
  //     "moderated": "À l'étude",
  //     "approved": "accepté",
  //     "rejected": "Rejeté",

  //     "months": [
  //       "Janvier",
  //       "Février",
  //       "Mars",
  //       "Avril",
  //       "Peut",
  //       "Juin",
  //       "Juillet",
  //       "Août",
  //       "Septembre",
  //       "Octobre",
  //       "Novembre",
  //       "Décembre"
  //     ],
  //       "successModalTitle": "Majorité mondiale pour un monde multipolaire",
  //       "successModalText": "Merci de votre inscription.",
  //       "restoreText": "Saisissez l'adresse email indiquée lors de votre inscription sur le site. ",
  //       "restoreTitle": "restaurer",
  //       "program": "Programme des excursions 17/02/2024",
  //       "checkbox1": "Exposition \"RUSSIE\"",
  //       "checkbox2": "Visite de Poklonnaïa Gora. ",
  //       "checkbox3": "Exposition « RUSSIE » et visite de Poklonnaya Gora.  ",
  //       "checkbox4": "je ne participerai pas",
  //       "restorePass": "Restaurer le mot de passe",
  //       "passLength": "Le mot de passe doit comporter au moins 6 caractères"
  //   },
  // }
};

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .use(LanguageDetector)
  .init({
    resources,
    fallbackLng: 'en',
    lng: userLang(),
    interpolation: {
      escapeValue: false // react already safes from xss
    }
  });

  export default i18n;
